import {configureStore} from '@reduxjs/toolkit';
import getCompHistory from './reducers/getCompHistory';
import getFooterTitleSlice from './reducers/getFooterTitleSlice';
import getHeaderTitleSlice from './reducers/getHeaderTitleSlice';
import getMarkersInfo from './reducers/getMarkersInfo';
import setHeaderNavSlice from './reducers/setHeaderNavSlice';

const store = configureStore({
  reducer:{
    //header(헤더메뉴에 들어가는 값들을 맵으로 불러오기 위해)
    HeaderTitles: getHeaderTitleSlice.reducer,
    //header-nav(모바일메뉴일때와 pc메뉴 구분) open or close state 저장
    HeaderNavState: setHeaderNavSlice.reducer,
    //footer(푸터메뉴에 들어가는 값들을 맵으로 불러오기 위해)
    FooterTitles: getFooterTitleSlice.reducer,
    //마리나시설 페이지 마커 정보
    MarkerInfo: getMarkersInfo.reducer,
    //회사연혁
    CompHist: getCompHistory.reducer,
  }
});

export default store;